import React, {
  useEffect,
  useState
} from "react";

import "./style.scss";

import BaseURL from "../../../assets/utils/baseUrl";

import {
  Link
} from "react-router-dom";

function Sidebar() {

  // =========================
  // STATE
  // =========================

  const [berita,
    setBerita] =
    useState([]);

  const [loading,
    setLoading] =
    useState(true);

  // =========================
  // FETCH BERITA
  // =========================

  useEffect(() => {

    const controller =
      new AbortController();

    const getData =
      async () => {

        try {

          setLoading(true);

          const response =
            await fetch(

              BaseURL +
              "index.php/api/Berita?jumlah_item=5",

              {
                method: "GET",

                headers: {
                  Accept:
                    "application/json",

                  "Content-Type":
                    "application/json",

                  // API KEY
                  "X-API-KEY":
                    process.env
                      .REACT_APP_API_KEY
                },

                signal:
                  controller.signal
              }
            );

          // =========================
          // VALIDASI HTTP
          // =========================

          if (!response.ok) {

            throw new Error(
              "HTTP Error " +
              response.status
            );
          }

          const result =
            await response.json();

          console.log(
            "SIDEBAR BERITA:",
            result
          );

          // =========================
          // VALIDASI DATA
          // =========================

          if (
            result &&
            result.status === true &&
            Array.isArray(
              result.data
            )
          ) {

            setBerita(
              result.data
            );

          } else {

            setBerita([]);
          }

        } catch (error) {

          if (
            error.name !==
            "AbortError"
          ) {

            console.error(
              "ERROR SIDEBAR:",
              error
            );
          }

          setBerita([]);

        } finally {

          setLoading(false);
        }
      };

    getData();

    return () =>
      controller.abort();

  }, []);

  // =========================
  // LOAD WIDGET KOMINFO
  // =========================

  useEffect(() => {

    // hindari duplicate script
    const existingScript =
      document.querySelector(
        'script[src="https://widget.kominfo.go.id/gpr-widget-kominfo.min.js"]'
      );

    if (!existingScript) {

      const script =
        document.createElement(
          "script"
        );

      script.src =
        "https://widget.kominfo.go.id/gpr-widget-kominfo.min.js";

      script.async = true;

      document.body.appendChild(
        script
      );
    }

  }, []);

  // =========================
  // RENDER
  // =========================

  return (

    <section className="sidebar">

      {/* ========================= */}
      {/* BERITA TERKINI */}
      {/* ========================= */}

      <div className="sidebar-panel">

        <div className="sidebar-title">

          Berita Terkini

        </div>

        <div className="sidebar-content">

          {
            loading ? (

              <div
                style={{
                  padding: "10px",
                  fontSize: "12px"
                }}
              >
                Loading...
              </div>

            ) : berita.length > 0 ? (

              berita.map(
                (item) => (

                  <Link
                    to={
                      "/berita-detail/" +
                      item.id_berita
                    }

                    className="sidebar-berita-wrapper"

                    key={
                      item.id_berita
                    }
                  >

                    <i className="fas fa-angle-right iconPlus"></i>

                    <div>

                      {
                        item.judul ||
                        "-"
                      }

                    </div>

                  </Link>
                )
              )

            ) : (

              <div
                style={{
                  padding: "10px",
                  fontSize: "12px"
                }}
              >
                Tidak ada berita
              </div>

            )
          }

        </div>

      </div>

      <div style={{ height: 10 }} />

      {/* ========================= */}
      {/* KOMINFO WIDGET */}
      {/* ========================= */}

      <div className="sidebar-panel">

        <div
          id="gpr-kominfo-widget-container"

          style={{
            width: "100%",
            minHeight: 200,
            overflow: "hidden"
          }}
        />

      </div>

    </section>
  );
}

export default Sidebar;